<template>
    <v-dialog v-model="getIsLoadingProgress" persistent width="300">
        <v-card dark>
            <v-card-text class="mt-2">
                Loading...
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    // name: 'Home',
    components: {
    },
    computed: {
        ...mapGetters(['getIsLoadingProgress']),
    },
    data() {
        return {

        };
    },
    mounted() {
        // this.GetGamePage();
    },
    methods: {
        
    }
};
</script>

